import { Injectable } from '@angular/core';
import { RestClientService } from 'src/app/core/services/rest/rest-client.service';
import { ConditionProfessionnel } from '../model/condition-professionnel';

@Injectable({
    providedIn: 'root'
  })
  export class ConditionProfessionnelService{
  
    constructor(private _restClientService : RestClientService) 
    {}

    getConditionProfessionnelsByProfessionnelItemId(requestItemId) {
      return this._restClientService.load<ConditionProfessionnel[]>('condition-professionnel/conditions-professionnel-by-professionnelitemid/'+requestItemId);
    }
    
    getConditionProfessionnelById(conditionId) {
      return this._restClientService.load<ConditionProfessionnel>('condition-professionnel/conditions-professionnel-by-id/'+conditionId);
    }
          
    putConditionProfessionnel(condition: ConditionProfessionnel) {
      return this._restClientService.put<void>('condition-professionnel/update-condition-professionnel', condition);
    }
  
    postConditionProfessionnel(condition: ConditionProfessionnel) {
      return this._restClientService.save<void>('condition-professionnel/add-condition-professionnel', condition);
    }

    deleteConditionProfessionnel(conditionId){
      return  this._restClientService.delete<void>('condition-professionnel/delete-condition-professionnel/'+conditionId);
    }


}      

    